<template>
  <div class="home">
    <van-nav-bar
      title="购物车"
      left-text="返回"
      right-text
      left-arrow
      fixed
      @click-left="onClickLeft"
    />
    <div style="height: 46px"></div>
    <div v-for="item in list" :key="item.id" class="group">
      <div class="merchant">
        {{ item.merchant_name }} {{ item.num_sum }}件 {{ item.price_sum }}元
      </div>
      <div class="g-list" v-for="g in item.goods" :key="g.id">
        <div class="l">
          <van-checkbox
            v-model="g.is_selected"
            v-on:click="changeSel(g.id)"
            icon-size="24px"
            checked-color="red"
          ></van-checkbox>
        </div>
        <div class="m">
          <van-image
            width="100"
            height="100"
            fit="contain"
            :src="GLOBAL.IMG + g.thumbnail"
          />
        </div>
        <div class="r">
          <router-link class="t" :to="'/shop/detail/' + g.goods_id">{{
            g.post_title
          }}</router-link>
          <div class="arrt">{{ g.attr }}</div>
          <div class="p">{{ g.price }}*{{ g.num }}</div>
          <div style="line-height: 22px; display: flex; margin-top: 10px">
            <img
              src="@/assets/jian.png"
              @click="changeNum(g.id, -1, g.num)"
              style="width: 22px; height: 22px"
            />
            <input
              type="text"
              :value="g.num"
              readonly
              style="
                margin: -5px 10px 0 10px;
                width: 50px;
                height: 30px;
                text-align: center;
                border: solid #b2b2b2 2px;
              "
            />

            <img
              src="@/assets/Add.png"
              @click="changeNum(g.id, 1)"
              style="width: 22px; height: 22px"
            />
          </div>
          <!-- <div class="o">删除</div> -->
        </div>
      </div>
    </div>
    <div style="padding: 0 20px">
      <van-button
        round
        type="danger"
        v-on:click="$router.push('/shop/createorder/0/cart')"
        size="large"
        color="#1baeae"
        >去结算</van-button
      >
    </div>
    <div style="height: 46px"></div>
  </div>
</template>
<script>
import Vue from "vue";
import { Checkbox, CheckboxGroup, Dialog } from "vant";

Vue.use(Checkbox);
Vue.use(CheckboxGroup).use(Dialog);
export default {
  name: "cart",
  data() {
    return {
      user: {},
      list: [],
    };
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    getList() {
      this.$http
        .get(this.GLOBAL.API + "s_shop/cart/cartList", {
          params: {},
          headers: { "XX-Token": this.user.token, "XX-Device-Type": "mobile" },
        })
        .then((response) => {
          let data = response.body;
          if (data.code == 1) {
            this.list = data.data;
          } else {
            this.$toast(data.msg);
          }
        });
    },
    changeSel(id) {
      this.$http
        .post(
          this.GLOBAL.API + "s_shop/cart/checkCart",
          { id: id },
          {
            params: {},
            headers: {
              "XX-Token": this.user.token,
              "XX-Device-Type": "mobile",
            },
          }
        )
        .then((response) => {
          let data = response.body;
          if (data.code == 1) {
            this.getList();
          } else {
            this.$toast(data.msg);
          }
        });
    },
    changeNum(id, num, cnum) {
      if (num == -1 && cnum == 1) {
        Dialog.confirm({
          title: "删除",
          message: "只剩下一个了，是否删除",
        })
          .then(() => {
            this.del(id);
          })
          .catch(() => {
            // on cancel
          });
      } else {
        this.$http
          .post(
            this.GLOBAL.API + "/s_shop/Cart/changeCart",
            { id: id, num: num },
            {
              params: {},
              headers: {
                "XX-Token": this.user.token,
                "XX-Device-Type": "mobile",
              },
            }
          )
          .then((response) => {
            let data = response.body;
            if (data.code == 1) {
              this.getList();
            }
            this.$toast(data.msg);
          });
      }
    },
    del(id) {
      this.$http
        .post(
          this.GLOBAL.API + "/s_shop/Cart/delCart",
          { id: id },
          {
            params: {},
            headers: {
              "XX-Token": this.user.token,
              "XX-Device-Type": "mobile",
            },
          }
        )
        .then((response) => {
          let data = response.body;
          if (data.code == 1) {
            this.getList();
          }
          this.$toast(data.msg);
        });
    },
  },
  mounted() {
    if (JSON.parse(localStorage.getItem("user"))) {
      this.user = JSON.parse(localStorage.getItem("user"));
      this.getList();
    }
  },
};
</script>
<style lang="scss" scoped>
.group {
  background-color: #fff;
  text-align: left;
  padding: 10px;
  .merchant {
    font-size: 18px;
    font-weight: 500;
  }
  .g-list {
    display: flex;
    margin-top: 10px;
    border-bottom: 1px solid #ebedf0;
    line-height: 22px;
    .l {
      width: 30px;
      align-self: center;
    }
    .m {
      width: 120px;
      padding: 0px 10px;
    }
    .r {
      flex-grow: 1;
      .t {
        height: 44px;
        display: block;
        overflow: hidden;
        color: #000;
      }
      .p {
        color: red;
      }
      .o {
        text-align: right;
        color: #999;
        padding-right: 30px;
      }
      .attr {
        height: 22px;
        overflow: hidden;
      }
    }
  }
}
</style>